import { IThongKeCanXuLy } from "../../../api/dashboard/thongKeCanXuLyApi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

/** Bộ số kèm BỐI CẢNH của nó — phải đi cùng nhau, không thì kết quả của kỳ cũ về muộn sẽ đè lên
 *  kỳ đang xem. */
export interface IThongKeCanXuLyKetQua {
  hoc_ky: number;
  nam_hoc: string;
  data: IThongKeCanXuLy;
}

export const eThongKeCanXuLyActionsObj = {
  LOAD_START: {} as { hoc_ky: number; nam_hoc: string },
  LOAD_SUCCESS: {} as IThongKeCanXuLyKetQua,
  LOAD_ERRR: "",

  /** Người dùng đã xem thông báo thay đổi ⇒ tắt cờ. */
  DA_XEM: undefined,
};

export const eThongKeCanXuLyActionTypeIds = generateActionTypeIds(
  eThongKeCanXuLyActionsObj,
  "THONG_KE_CAN_XU_LY",
);

export type IThongKeCanXuLyActionTypes = IGenericActionType<
  typeof eThongKeCanXuLyActionsObj,
  "THONG_KE_CAN_XU_LY"
>;
